export const fetchData = async () => {
    const response = await fetch('https://api.apify.com/v2/acts/apify~web-scraper/runs/last/dataset/items?token=apify_api_i7NQhn9WZBXBSSNwTEPhyqO2RthLOb46XCVS')
    if (!response.ok) {
        throw new Error('An error occurred while fetching data')
    }
    return await response.json()
}
